const ProductDetail = [
      {
        productID: 1,
        images: [
          "path/to/image1.jpg",
          "path/to/image2.jpg",
          "path/to/image3.jpg",
          "path/to/image4.jpg"
        ],
        description: "Crafted from Pure 925 Sterling Silver for unmatched quality and durability. Exquisite Designs, from minimalistic elegance to bold statement pieces.",
        additionalInfo: {
          mainHeader: "Sed d labore",
          mainDescription: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
          weight: "1.25 kg",
          dimensions: "90 x 60 x 90 cm",
          size: ["XS", "S", "M", "L", "XL"],
          color: ["Black", "Orange", "White"],
          storage: "Relaxed fit shirt-style dress with a rugged",
          lining: "925 silver, Italian imported metal",
          whyChoose: [
            "Crafted from Pure 925 Sterling Silver for unmatched quality and durability.",
            "Exquisite Designs, from minimalistic elegance to bold statement pieces.",
            "Perfect for Every Occasion – Weddings, parties, or daily wear.",
            "Handpicked Stones & Premium Finishing for a luxurious look.",
            "Nationwide Delivery & Pickup from Hussain Center, Karachi."
          ],
          shopWithConfidence: [
            "Premium Quality – 100% authentic sterling silver.",
            "Exclusive Designs – Curated to match your unique style.",
            "Safe & Secure Shopping – Hassle-free checkout and reliable delivery."
          ]
        },
        reviews: [
          {
            user: "Janice Miller",
            date: "April 06, 2023",
            rating: 5,
            comment: "Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus, omnis voluptas assumenda est…"
          },
          {
            user: "Benjam Porter",
            date: "April 12, 2023",
            rating: 4,
            comment: "Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus, omnis voluptas assumenda est…"
          }
        ]
      },
    
      // Product 2
      {
        productID: 2,
        images: [
          "path/to/image1.jpg",
          "path/to/image2.jpg",
          "path/to/image3.jpg",
          "path/to/image4.jpg"
        ],
        description: "A stunning bracelet designed with celestial charms, perfect for adding a touch of elegance to any outfit.",
        additionalInfo: {
          mainHeader: "Celestial Charm Bracelet",
          mainDescription: "This bracelet features intricate celestial charms that symbolize the beauty of the night sky. Crafted with precision and care, it is perfect for any occasion.",
          weight: "0.5 kg",
          dimensions: "20 x 2 x 2 cm",
          size: ["S", "M", "L"],
          color: ["Gold", "Silver"],
          storage: "Store in a cool, dry place.",
          lining: "Gold-plated metal",
          whyChoose: [
            "Exquisite celestial charm design.",
            "High-quality gold-plated metal.",
            "Perfect for gifting or personal use.",
            "Durable and long-lasting.",
            "Available in multiple sizes."
          ],
          shopWithConfidence: [
            "Premium Quality – 100% authentic materials.",
            "Exclusive Designs – Unique celestial charm design.",
            "Safe & Secure Shopping – Hassle-free checkout and reliable delivery."
          ]
        },
        reviews: [
          {
            user: "Sarah Johnson",
            date: "May 01, 2023",
            rating: 5,
            comment: "Absolutely love this bracelet! The charms are so detailed and beautiful. Highly recommend!"
          },
          {
            user: "Michael Brown",
            date: "May 10, 2023",
            rating: 4,
            comment: "Great quality and design. The bracelet looks even better in person."
          }
        ]
      },
    
      // Product 3
      {
        productID: 3,
        images: [
          "path/to/image1.jpg",
          "path/to/image2.jpg",
          "path/to/image3.jpg",
          "path/to/image4.jpg"
        ],
        description: "A delicate necklace featuring ethereal blossom designs, perfect for adding a touch of elegance to any outfit.",
        additionalInfo: {
          mainHeader: "Ethereal Blossom Necklace",
          mainDescription: "This necklace features delicate blossom designs that symbolize beauty and grace. Crafted with precision and care, it is perfect for any occasion.",
          weight: "0.3 kg",
          dimensions: "30 x 1 x 1 cm",
          size: ["One Size"],
          color: ["Silver"],
          storage: "Store in a cool, dry place.",
          lining: "925 Sterling Silver",
          whyChoose: [
            "Exquisite blossom design.",
            "High-quality 925 Sterling Silver.",
            "Perfect for gifting or personal use.",
            "Durable and long-lasting.",
            "Elegant and timeless design."
          ],
          shopWithConfidence: [
            "Premium Quality – 100% authentic materials.",
            "Exclusive Designs – Unique blossom design.",
            "Safe & Secure Shopping – Hassle-free checkout and reliable delivery."
          ]
        },
        reviews: [
          {
            user: "Emily Davis",
            date: "June 15, 2023",
            rating: 5,
            comment: "This necklace is absolutely stunning! The design is so elegant and delicate. I love it!"
          },
          {
            user: "David Wilson",
            date: "June 20, 2023",
            rating: 4,
            comment: "Great quality and design. The necklace looks even better in person."
          }
        ]
      },
    
      // Product 4
      {
        productID: 4,
        images: [
          "path/to/image1.jpg",
          "path/to/image2.jpg",
          "path/to/image3.jpg",
          "path/to/image4.jpg"
        ],
        description: "A serene silver band that combines simplicity with elegance, perfect for everyday wear.",
        additionalInfo: {
          mainHeader: "Serenity Silver Band",
          mainDescription: "This silver band is designed for those who appreciate minimalistic elegance. Its smooth finish and comfortable fit make it ideal for daily wear.",
          weight: "0.2 kg",
          dimensions: "18 x 0.5 x 0.5 cm",
          size: ["S", "M", "L"],
          color: ["Silver"],
          storage: "Store in a cool, dry place.",
          lining: "925 Sterling Silver",
          whyChoose: [
            "Minimalistic and elegant design.",
            "High-quality 925 Sterling Silver.",
            "Perfect for everyday wear.",
            "Comfortable and durable.",
            "Available in multiple sizes."
          ],
          shopWithConfidence: [
            "Premium Quality – 100% authentic materials.",
            "Exclusive Designs – Simple yet elegant.",
            "Safe & Secure Shopping – Hassle-free checkout and reliable delivery."
          ]
        },
        reviews: [
          {
            user: "Laura Smith",
            date: "July 05, 2023",
            rating: 5,
            comment: "Love this band! It's so simple yet elegant. Perfect for everyday wear."
          },
          {
            user: "James White",
            date: "July 10, 2023",
            rating: 4,
            comment: "Great quality and comfortable fit. Highly recommend!"
          }
        ]
      },
    
      // Product 5
      {
        productID: 5,
        images: [
          "path/to/image1.jpg",
          "path/to/image2.jpg",
          "path/to/image3.jpg",
          "path/to/image4.jpg"
        ],
        description: "An enchanted bangle featuring intricate ivy designs, perfect for adding a touch of nature-inspired elegance to your look.",
        additionalInfo: {
          mainHeader: "Enchanted Ivy Bangle",
          mainDescription: "This bangle features intricate ivy designs that symbolize growth and vitality. Crafted with precision and care, it is perfect for any occasion.",
          weight: "0.4 kg",
          dimensions: "19 x 2 x 2 cm",
          size: ["S", "M", "L"],
          color: ["Gold"],
          storage: "Store in a cool, dry place.",
          lining: "Gold-plated metal",
          whyChoose: [
            "Exquisite ivy design.",
            "High-quality gold-plated metal.",
            "Perfect for gifting or personal use.",
            "Durable and long-lasting.",
            "Available in multiple sizes."
          ],
          shopWithConfidence: [
            "Premium Quality – 100% authentic materials.",
            "Exclusive Designs – Unique ivy design.",
            "Safe & Secure Shopping – Hassle-free checkout and reliable delivery."
          ]
        },
        reviews: [
          {
            user: "Olivia Green",
            date: "August 01, 2023",
            rating: 5,
            comment: "This bangle is absolutely beautiful! The ivy design is so detailed and elegant."
          },
          {
            user: "William Brown",
            date: "August 05, 2023",
            rating: 4,
            comment: "Great quality and design. The bangle looks even better in person."
          }
        ]
      },
    
      // Product 6
      {
        productID: 6,
        images: [
          "path/to/image1.jpg",
          "path/to/image2.jpg",
          "path/to/image3.jpg",
          "path/to/image4.jpg"
        ],
        description: "Stunning earrings featuring a cascade of stars, perfect for adding a touch of sparkle to any outfit.",
        additionalInfo: {
          mainHeader: "Starlit Cascade Earrings",
          mainDescription: "These earrings feature a cascade of stars that symbolize the beauty of the night sky. Crafted with precision and care, they are perfect for any occasion.",
          weight: "0.1 kg",
          dimensions: "5 x 2 x 2 cm",
          size: ["One Size"],
          color: ["Silver"],
          storage: "Store in a cool, dry place.",
          lining: "925 Sterling Silver",
          whyChoose: [
            "Exquisite star design.",
            "High-quality 925 Sterling Silver.",
            "Perfect for gifting or personal use.",
            "Durable and long-lasting.",
            "Elegant and timeless design."
          ],
          shopWithConfidence: [
            "Premium Quality – 100% authentic materials.",
            "Exclusive Designs – Unique star design.",
            "Safe & Secure Shopping – Hassle-free checkout and reliable delivery."
          ]
        },
        reviews: [
          {
            user: "Sophia Taylor",
            date: "September 01, 2023",
            rating: 5,
            comment: "These earrings are absolutely stunning! The star design is so elegant and sparkly."
          },
          {
            user: "Daniel Harris",
            date: "September 05, 2023",
            rating: 4,
            comment: "Great quality and design. The earrings look even better in person."
          }
        ]
      },
    
      // Product 7
      {
        productID: 7,
        images: [
          "path/to/image1.jpg",
          "path/to/image2.jpg",
          "path/to/image3.jpg",
          "path/to/image4.jpg"
        ],
        description: "A twilight-inspired necklace featuring a stunning empress design, perfect for adding a touch of royalty to your look.",
        additionalInfo: {
          mainHeader: "Twilight Empress Necklace",
          mainDescription: "This necklace features a stunning empress design that symbolizes power and elegance. Crafted with precision and care, it is perfect for any occasion.",
          weight: "0.3 kg",
          dimensions: "30 x 1 x 1 cm",
          size: ["One Size"],
          color: ["Silver"],
          storage: "Store in a cool, dry place.",
          lining: "925 Sterling Silver",
          whyChoose: [
            "Exquisite empress design.",
            "High-quality 925 Sterling Silver.",
            "Perfect for gifting or personal use.",
            "Durable and long-lasting.",
            "Elegant and timeless design."
          ],
          shopWithConfidence: [
            "Premium Quality – 100% authentic materials.",
            "Exclusive Designs – Unique empress design.",
            "Safe & Secure Shopping – Hassle-free checkout and reliable delivery."
          ]
        },
        reviews: [
          {
            user: "Emma Wilson",
            date: "October 01, 2023",
            rating: 5,
            comment: "This necklace is absolutely stunning! The empress design is so elegant and regal."
          },
          {
            user: "Noah Martinez",
            date: "October 05, 2023",
            rating: 4,
            comment: "Great quality and design. The necklace looks even better in person."
          }
        ]
      },
    
      // Product 8
      {
        productID: 8,
        images: [
          "path/to/image1.jpg",
          "path/to/image2.jpg",
          "path/to/image3.jpg",
          "path/to/image4.jpg"
        ],
        description: "A lustrous pearl choker that combines classic elegance with modern design, perfect for any formal occasion.",
        additionalInfo: {
          mainHeader: "Lustrous Pearl Choker",
          mainDescription: "This choker features lustrous pearls that symbolize timeless elegance. Crafted with precision and care, it is perfect for any formal occasion.",
          weight: "0.2 kg",
          dimensions: "35 x 1 x 1 cm",
          size: ["One Size"],
          color: ["Gold"],
          storage: "Store in a cool, dry place.",
          lining: "Gold-plated metal",
          whyChoose: [
            "Exquisite pearl design.",
            "High-quality gold-plated metal.",
            "Perfect for gifting or personal use.",
            "Durable and long-lasting.",
            "Elegant and timeless design."
          ],
          shopWithConfidence: [
            "Premium Quality – 100% authentic materials.",
            "Exclusive Designs – Unique pearl design.",
            "Safe & Secure Shopping – Hassle-free checkout and reliable delivery."
          ]
        },
        reviews: [
          {
            user: "Ava Anderson",
            date: "November 01, 2023",
            rating: 5,
            comment: "This choker is absolutely stunning! The pearls are so elegant and timeless."
          },
          {
            user: "Liam Thomas",
            date: "November 05, 2023",
            rating: 4,
            comment: "Great quality and design. The choker looks even better in person."
          }
        ]
      },
          // Product 9
    {
      productID: 9,
      images: ["path/to/image1.jpg", "path/to/image2.jpg", "path/to/image3.jpg", "path/to/image4.jpg"],
      description: "A radiant pendant that captures the brilliance of a halo, crafted from 925 Sterling Silver.",
      additionalInfo: {
        mainHeader: "Radiance Halo Pendant",
        mainDescription: "This pendant symbolizes celestial elegance, perfect for special occasions and everyday wear.",
        weight: "0.2 kg",
        dimensions: "4 x 2 x 1 cm",
        size: ["One Size"],
        color: ["Silver"],
        storage: "Store in a cool, dry place.",
        lining: "925 Sterling Silver",
        whyChoose: [
          "Elegant halo-inspired design.",
          "High-quality 925 Sterling Silver.",
          "Perfect for gifting or personal use.",
          "Lightweight and comfortable to wear.",
          "Timeless appeal."
        ],
        shopWithConfidence: [
          "Premium Quality – 100% authentic materials.",
          "Exclusive Designs – Unique celestial-inspired piece.",
          "Safe & Secure Shopping – Hassle-free checkout and reliable delivery."
        ]
      },
      reviews: []
    },
    
    // Product 10
    {
      productID: 10,
      images: ["path/to/image1.jpg", "path/to/image2.jpg", "path/to/image3.jpg", "path/to/image4.jpg"],
      description: "A bold and elegant gold cuff that radiates luxury and sophistication.",
      additionalInfo: {
        mainHeader: "Golden Aurora Cuff",
        mainDescription: "A statement cuff designed to enhance any outfit with a touch of glamour.",
        weight: "0.4 kg",
        dimensions: "6 x 4 x 2 cm",
        size: ["Adjustable"],
        color: ["Gold"],
        storage: "Store in a soft pouch to avoid scratches.",
        lining: "Gold-Plated Metal",
        whyChoose: [
          "Luxurious gold-plated finish.",
          "Adjustable fit for comfort.",
          "Perfect for formal and casual wear.",
          "Durable and stylish.",
          "An exquisite gift choice."
        ],
        shopWithConfidence: [
          "High-Quality Craftsmanship.",
          "Exclusive & Elegant Design.",
          "Secure Shopping & Reliable Delivery."
        ]
      },
      reviews: []
    },
    
    // Product 11
    {
      productID: 11,
      images: ["path/to/image1.jpg", "path/to/image2.jpg", "path/to/image3.jpg", "path/to/image4.jpg"],
      description: "A delicate anklet adorned with shimmering opal stones, exuding grace and charm.",
      additionalInfo: {
        mainHeader: "Opulent Gleam Anklet",
        mainDescription: "Designed for elegance, this anklet is the perfect blend of style and comfort.",
        weight: "0.15 kg",
        dimensions: "22 x 1 x 1 cm",
        size: ["Adjustable"],
        color: ["Gold"],
        storage: "Keep away from moisture for lasting shine.",
        lining: "Gold-Plated Metal with Opal Stones",
        whyChoose: [
          "Elegant opal detailing.",
          "Comfortable and lightweight.",
          "Perfect for daily wear.",
          "Trendy and stylish.",
          "A great gifting option."
        ],
        shopWithConfidence: [
          "100% Authentic Materials.",
          "Handcrafted for Uniqueness.",
          "Hassle-Free Shopping Experience."
        ]
      },
      reviews: []
    },
    
    // Product 12
    {
      productID: 12,
      images: ["path/to/image1.jpg", "path/to/image2.jpg", "path/to/image3.jpg", "path/to/image4.jpg"],
      description: "A dazzling engagement ring crafted with intricate details and a brilliant finish.",
      additionalInfo: {
        mainHeader: "Iridescent Grace Ring",
        mainDescription: "This stunning ring is a symbol of eternal love and elegance, perfect for engagements or special occasions.",
        weight: "0.3 kg",
        dimensions: "2 x 2 x 1 cm",
        size: ["6", "7", "8", "9"],
        color: ["Gold"],
        storage: "Store in a ring box to prevent scratches.",
        lining: "Gold-Plated Metal",
        whyChoose: [
          "Exquisite craftsmanship.",
          "Luxurious gold-plated design.",
          "Perfect for engagements or gifts.",
          "Durable and elegant.",
          "A timeless beauty."
        ],
        shopWithConfidence: [
          "Premium Materials.",
          "Exclusive & Unique Design.",
          "Hassle-Free Secure Shopping."
        ]
      },
      reviews: []
    },
      // Product 13
  {
    productID: 13,
    images: [
      "path/to/image1.jpg",
      "path/to/image2.jpg",
      "path/to/image3.jpg",
      "path/to/image4.jpg"
    ],
    description: "A majestic bracelet with a noir-inspired design, perfect for adding a touch of sophistication to your look.",
    additionalInfo: {
      mainHeader: "Majestic Noir Bracelet",
      mainDescription: "This bracelet features a bold, noir-inspired design that exudes elegance and strength. Crafted with precision, it is perfect for any formal occasion.",
      weight: "0.35 kg",
      dimensions: "18 x 2 x 2 cm",
      size: ["S", "M", "L"],
      color: ["Black", "Gold"],
      storage: "Store in a cool, dry place.",
      lining: "Gold-plated metal",
      whyChoose: [
        "Bold and sophisticated design.",
        "High-quality gold-plated metal.",
        "Perfect for formal occasions.",
        "Durable and long-lasting.",
        "Available in multiple sizes."
      ],
      shopWithConfidence: [
        "Premium Quality – 100% authentic materials.",
        "Exclusive Designs – Unique noir-inspired design.",
        "Safe & Secure Shopping – Hassle-free checkout and reliable delivery."
      ]
    },
    reviews: [
      {
        user: "Sophia Clark",
        date: "December 01, 2023",
        rating: 5,
        comment: "This bracelet is absolutely stunning! The noir design is so elegant and unique."
      },
      {
        user: "Ethan Harris",
        date: "December 05, 2023",
        rating: 4,
        comment: "Great quality and design. The bracelet looks even better in person."
      }
    ]
  },

  // Product 14
  {
    productID: 14,
    images: [
      "path/to/image1.jpg",
      "path/to/image2.jpg",
      "path/to/image3.jpg",
      "path/to/image4.jpg"
    ],
    description: "A royal bangle with an empress-inspired design, perfect for adding a regal touch to your ensemble.",
    additionalInfo: {
      mainHeader: "Royal Empress Bangle",
      mainDescription: "This bangle features an empress-inspired design that symbolizes power and elegance. Crafted with precision, it is perfect for any formal occasion.",
      weight: "0.4 kg",
      dimensions: "19 x 2 x 2 cm",
      size: ["S", "M", "L"],
      color: ["Gold"],
      storage: "Store in a cool, dry place.",
      lining: "Gold-plated metal",
      whyChoose: [
        "Regal and elegant design.",
        "High-quality gold-plated metal.",
        "Perfect for formal occasions.",
        "Durable and long-lasting.",
        "Available in multiple sizes."
      ],
      shopWithConfidence: [
        "Premium Quality – 100% authentic materials.",
        "Exclusive Designs – Unique empress-inspired design.",
        "Safe & Secure Shopping – Hassle-free checkout and reliable delivery."
      ]
    },
    reviews: [
      {
        user: "Olivia Martinez",
        date: "November 15, 2023",
        rating: 5,
        comment: "This bangle is absolutely stunning! The empress design is so elegant and regal."
      },
      {
        user: "Liam Johnson",
        date: "November 20, 2023",
        rating: 4,
        comment: "Great quality and design. The bangle looks even better in person."
      }
    ]
  },

  // Product 15
  {
    productID: 15,
    images: [
      "path/to/image1.jpg",
      "path/to/image2.jpg",
      "path/to/image3.jpg",
      "path/to/image4.jpg"
    ],
    description: "A midnight-inspired necklace that captures the glimmer of the night sky, perfect for adding a touch of mystery to your look.",
    additionalInfo: {
      mainHeader: "Midnight Glimmer Necklace",
      mainDescription: "This necklace features a midnight-inspired design that symbolizes the beauty of the night sky. Crafted with precision, it is perfect for any occasion.",
      weight: "0.3 kg",
      dimensions: "30 x 1 x 1 cm",
      size: ["One Size"],
      color: ["Gold"],
      storage: "Store in a cool, dry place.",
      lining: "Gold-plated metal",
      whyChoose: [
        "Exquisite midnight-inspired design.",
        "High-quality gold-plated metal.",
        "Perfect for gifting or personal use.",
        "Durable and long-lasting.",
        "Elegant and timeless design."
      ],
      shopWithConfidence: [
        "Premium Quality – 100% authentic materials.",
        "Exclusive Designs – Unique midnight-inspired design.",
        "Safe & Secure Shopping – Hassle-free checkout and reliable delivery."
      ]
    },
    reviews: [
      {
        user: "Emma Wilson",
        date: "October 10, 2023",
        rating: 5,
        comment: "This necklace is absolutely stunning! The midnight design is so elegant and mysterious."
      },
      {
        user: "Noah Martinez",
        date: "October 15, 2023",
        rating: 4,
        comment: "Great quality and design. The necklace looks even better in person."
      }
    ]
  },

  // Product 16
  {
    productID: 16,
    images: [
      "path/to/image1.jpg",
      "path/to/image2.jpg",
      "path/to/image3.jpg",
      "path/to/image4.jpg"
    ],
    description: "A twilight-inspired ring that captures the sparkle of the evening sky, perfect for adding a touch of elegance to your look.",
    additionalInfo: {
      mainHeader: "Twilight Sparkle Ring",
      mainDescription: "This ring features a twilight-inspired design that symbolizes the beauty of the evening sky. Crafted with precision, it is perfect for any occasion.",
      weight: "0.25 kg",
      dimensions: "2 x 2 x 1 cm",
      size: ["6", "7", "8", "9"],
      color: ["Gold"],
      storage: "Store in a cool, dry place.",
      lining: "Gold-plated metal",
      whyChoose: [
        "Exquisite twilight-inspired design.",
        "High-quality gold-plated metal.",
        "Perfect for gifting or personal use.",
        "Durable and long-lasting.",
        "Elegant and timeless design."
      ],
      shopWithConfidence: [
        "Premium Quality – 100% authentic materials.",
        "Exclusive Designs – Unique twilight-inspired design.",
        "Safe & Secure Shopping – Hassle-free checkout and reliable delivery."
      ]
    },
    reviews: [
      {
        user: "Ava Anderson",
        date: "September 10, 2023",
        rating: 5,
        comment: "This ring is absolutely stunning! The twilight design is so elegant and sparkly."
      },
      {
        user: "Liam Thomas",
        date: "September 15, 2023",
        rating: 4,
        comment: "Great quality and design. The ring looks even better in person."
      }
    ]
  },

  // Product 17
  {
    productID: 17,
    images: [
      "path/to/image1.jpg",
      "path/to/image2.jpg",
      "path/to/image3.jpg",
      "path/to/image4.jpg"
    ],
    description: "Golden earrings that capture the essence of a mirage, perfect for adding a touch of luxury to your look.",
    additionalInfo: {
      mainHeader: "Golden Mirage Earrings",
      mainDescription: "These earrings feature a mirage-inspired design that symbolizes the beauty of illusion. Crafted with precision, they are perfect for any occasion.",
      weight: "0.15 kg",
      dimensions: "5 x 2 x 2 cm",
      size: ["One Size"],
      color: ["Gold"],
      storage: "Store in a cool, dry place.",
      lining: "Gold-plated metal",
      whyChoose: [
        "Exquisite mirage-inspired design.",
        "High-quality gold-plated metal.",
        "Perfect for gifting or personal use.",
        "Durable and long-lasting.",
        "Elegant and timeless design."
      ],
      shopWithConfidence: [
        "Premium Quality – 100% authentic materials.",
        "Exclusive Designs – Unique mirage-inspired design.",
        "Safe & Secure Shopping – Hassle-free checkout and reliable delivery."
      ]
    },
    reviews: [
      {
        user: "Sophia Taylor",
        date: "August 10, 2023",
        rating: 5,
        comment: "These earrings are absolutely stunning! The mirage design is so elegant and luxurious."
      },
      {
        user: "Daniel Harris",
        date: "August 15, 2023",
        rating: 4,
        comment: "Great quality and design. The earrings look even better in person."
      }
    ]
  },
   // Product 18
   {
    productID: 18,
    images: [
      "path/to/image1.jpg",
      "path/to/image2.jpg",
      "path/to/image3.jpg",
      "path/to/image4.jpg"
    ],
    description: "A mystic sapphire choker that combines elegance with a touch of mystery, perfect for formal occasions.",
    additionalInfo: {
      mainHeader: "Mystic Sapphire Choker",
      mainDescription: "This choker features a stunning sapphire stone that symbolizes wisdom and royalty. Crafted with precision, it is perfect for adding a regal touch to your ensemble.",
      weight: "0.25 kg",
      dimensions: "35 x 1 x 1 cm",
      size: ["One Size"],
      color: ["Gold"],
      storage: "Store in a cool, dry place.",
      lining: "Gold-plated metal",
      whyChoose: [
        "Exquisite sapphire stone design.",
        "High-quality gold-plated metal.",
        "Perfect for formal occasions.",
        "Durable and long-lasting.",
        "Elegant and timeless design."
      ],
      shopWithConfidence: [
        "Premium Quality – 100% authentic materials.",
        "Exclusive Designs – Unique sapphire design.",
        "Safe & Secure Shopping – Hassle-free checkout and reliable delivery."
      ]
    },
    reviews: [
      {
        user: "Sophia Clark",
        date: "December 10, 2023",
        rating: 5,
        comment: "This choker is absolutely stunning! The sapphire stone is so elegant and regal."
      },
      {
        user: "Ethan Harris",
        date: "December 15, 2023",
        rating: 4,
        comment: "Great quality and design. The choker looks even better in person."
      }
    ]
  },

  // Product 19
  {
    productID: 19,
    images: [
      "path/to/image1.jpg",
      "path/to/image2.jpg",
      "path/to/image3.jpg",
      "path/to/image4.jpg"
    ],
    description: "A velvet moon pendant that captures the essence of the night sky, perfect for adding a touch of elegance to your look.",
    additionalInfo: {
      mainHeader: "Velvet Moon Pendant",
      mainDescription: "This pendant features a velvet moon design that symbolizes mystery and beauty. Crafted with precision, it is perfect for any occasion.",
      weight: "0.2 kg",
      dimensions: "4 x 2 x 1 cm",
      size: ["One Size"],
      color: ["Gold"],
      storage: "Store in a cool, dry place.",
      lining: "Gold-plated metal",
      whyChoose: [
        "Elegant moon-inspired design.",
        "High-quality gold-plated metal.",
        "Perfect for gifting or personal use.",
        "Lightweight and comfortable to wear.",
        "Timeless appeal."
      ],
      shopWithConfidence: [
        "Premium Quality – 100% authentic materials.",
        "Exclusive Designs – Unique moon-inspired piece.",
        "Safe & Secure Shopping – Hassle-free checkout and reliable delivery."
      ]
    },
    reviews: [
      {
        user: "Olivia Martinez",
        date: "November 25, 2023",
        rating: 5,
        comment: "This pendant is absolutely beautiful! The moon design is so elegant and mysterious."
      },
      {
        user: "Liam Johnson",
        date: "November 30, 2023",
        rating: 4,
        comment: "Great quality and design. The pendant looks even better in person."
      }
    ]
  },

  // Product 20
  {
    productID: 20,
    images: [
      "path/to/image1.jpg",
      "path/to/image2.jpg",
      "path/to/image3.jpg",
      "path/to/image4.jpg"
    ],
    description: "Seraphic halo earrings that capture the essence of celestial beauty, perfect for adding a touch of elegance to your look.",
    additionalInfo: {
      mainHeader: "Seraphic Halo Earrings",
      mainDescription: "These earrings feature a halo-inspired design that symbolizes celestial beauty. Crafted with precision, they are perfect for any occasion.",
      weight: "0.15 kg",
      dimensions: "5 x 2 x 2 cm",
      size: ["One Size"],
      color: ["Gold"],
      storage: "Store in a cool, dry place.",
      lining: "Gold-plated metal",
      whyChoose: [
        "Exquisite halo-inspired design.",
        "High-quality gold-plated metal.",
        "Perfect for gifting or personal use.",
        "Durable and long-lasting.",
        "Elegant and timeless design."
      ],
      shopWithConfidence: [
        "Premium Quality – 100% authentic materials.",
        "Exclusive Designs – Unique halo-inspired design.",
        "Safe & Secure Shopping – Hassle-free checkout and reliable delivery."
      ]
    },
    reviews: [
      {
        user: "Emma Wilson",
        date: "October 20, 2023",
        rating: 5,
        comment: "These earrings are absolutely stunning! The halo design is so elegant and sparkly."
      },
      {
        user: "Noah Martinez",
        date: "October 25, 2023",
        rating: 4,
        comment: "Great quality and design. The earrings look even better in person."
      }
    ]
  },

  // Product 21
  {
    productID: 21,
    images: [
      "path/to/image1.jpg",
      "path/to/image2.jpg",
      "path/to/image3.jpg",
      "path/to/image4.jpg"
    ],
    description: "A celestial glow ring that captures the essence of the stars, perfect for adding a touch of elegance to your look.",
    additionalInfo: {
      mainHeader: "Celestial Glow Ring",
      mainDescription: "This ring features a celestial-inspired design that symbolizes the beauty of the stars. Crafted with precision, it is perfect for any occasion.",
      weight: "0.25 kg",
      dimensions: "2 x 2 x 1 cm",
      size: ["6", "7", "8", "9"],
      color: ["Gold"],
      storage: "Store in a cool, dry place.",
      lining: "Gold-plated metal",
      whyChoose: [
        "Exquisite celestial-inspired design.",
        "High-quality gold-plated metal.",
        "Perfect for gifting or personal use.",
        "Durable and long-lasting.",
        "Elegant and timeless design."
      ],
      shopWithConfidence: [
        "Premium Quality – 100% authentic materials.",
        "Exclusive Designs – Unique celestial-inspired design.",
        "Safe & Secure Shopping – Hassle-free checkout and reliable delivery."
      ]
    },
    reviews: [
      {
        user: "Ava Anderson",
        date: "September 20, 2023",
        rating: 5,
        comment: "This ring is absolutely stunning! The celestial design is so elegant and sparkly."
      },
      {
        user: "Liam Thomas",
        date: "September 25, 2023",
        rating: 4,
        comment: "Great quality and design. The ring looks even better in person."
      }
    ]
  },

  // Product 22
  {
    productID: 22,
    images: [
      "path/to/image1.jpg",
      "path/to/image2.jpg",
      "path/to/image3.jpg",
      "path/to/image4.jpg"
    ],
    description: "An eclipse charm bracelet that captures the essence of celestial beauty, perfect for adding a touch of elegance to your look.",
    additionalInfo: {
      mainHeader: "Eclipse Charm Bracelet",
      mainDescription: "This bracelet features an eclipse-inspired design that symbolizes the beauty of celestial events. Crafted with precision, it is perfect for any occasion.",
      weight: "0.3 kg",
      dimensions: "18 x 2 x 2 cm",
      size: ["S", "M", "L"],
      color: ["Gold"],
      storage: "Store in a cool, dry place.",
      lining: "Gold-plated metal",
      whyChoose: [
        "Exquisite eclipse-inspired design.",
        "High-quality gold-plated metal.",
        "Perfect for gifting or personal use.",
        "Durable and long-lasting.",
        "Elegant and timeless design."
      ],
      shopWithConfidence: [
        "Premium Quality – 100% authentic materials.",
        "Exclusive Designs – Unique eclipse-inspired design.",
        "Safe & Secure Shopping – Hassle-free checkout and reliable delivery."
      ]
    },
    reviews: [
      {
        user: "Sophia Taylor",
        date: "August 20, 2023",
        rating: 5,
        comment: "This bracelet is absolutely stunning! The eclipse design is so elegant and unique."
      },
      {
        user: "Daniel Harris",
        date: "August 25, 2023",
        rating: 4,
        comment: "Great quality and design. The bracelet looks even better in person."
      }
    ]
  },
  // Product 23
  {
    productID: 23,
    images: [
      "path/to/image1.jpg",
      "path/to/image2.jpg",
      "path/to/image3.jpg",
      "path/to/image4.jpg"
    ],
    description: "An ethereal starlight necklace that captures the essence of the night sky, perfect for adding a touch of celestial elegance to your look.",
    additionalInfo: {
      mainHeader: "Ethereal Starlight Necklace",
      mainDescription: "This necklace features a starlight-inspired design that symbolizes the beauty of the night sky. Crafted with precision, it is perfect for any occasion.",
      weight: "0.3 kg",
      dimensions: "30 x 1 x 1 cm",
      size: ["One Size"],
      color: ["Gold"],
      storage: "Store in a cool, dry place.",
      lining: "Gold-plated metal",
      whyChoose: [
        "Exquisite starlight-inspired design.",
        "High-quality gold-plated metal.",
        "Perfect for gifting or personal use.",
        "Durable and long-lasting.",
        "Elegant and timeless design."
      ],
      shopWithConfidence: [
        "Premium Quality – 100% authentic materials.",
        "Exclusive Designs – Unique starlight-inspired design.",
        "Safe & Secure Shopping – Hassle-free checkout and reliable delivery."
      ]
    },
    reviews: [
      {
        user: "Emma Wilson",
        date: "October 10, 2023",
        rating: 5,
        comment: "This necklace is absolutely stunning! The starlight design is so elegant and mesmerizing."
      },
      {
        user: "Noah Martinez",
        date: "October 15, 2023",
        rating: 4,
        comment: "Great quality and design. The necklace looks even better in person."
      }
    ]
  },

  // Product 24
  {
    productID: 24,
    images: [
      "path/to/image1.jpg",
      "path/to/image2.jpg",
      "path/to/image3.jpg",
      "path/to/image4.jpg"
    ],
    description: "A gleaming horizon band that combines simplicity with elegance, perfect for everyday wear.",
    additionalInfo: {
      mainHeader: "Gleaming Horizon Band",
      mainDescription: "This band is designed for those who appreciate minimalistic elegance. Its smooth finish and comfortable fit make it ideal for daily wear.",
      weight: "0.2 kg",
      dimensions: "18 x 0.5 x 0.5 cm",
      size: ["S", "M", "L"],
      color: ["Gold"],
      storage: "Store in a cool, dry place.",
      lining: "Gold-plated metal",
      whyChoose: [
        "Minimalistic and elegant design.",
        "High-quality gold-plated metal.",
        "Perfect for everyday wear.",
        "Comfortable and durable.",
        "Available in multiple sizes."
      ],
      shopWithConfidence: [
        "Premium Quality – 100% authentic materials.",
        "Exclusive Designs – Simple yet elegant.",
        "Safe & Secure Shopping – Hassle-free checkout and reliable delivery."
      ]
    },
    reviews: [
      {
        user: "Laura Smith",
        date: "July 05, 2023",
        rating: 5,
        comment: "Love this band! It's so simple yet elegant. Perfect for everyday wear."
      },
      {
        user: "James White",
        date: "July 10, 2023",
        rating: 4,
        comment: "Great quality and comfortable fit. Highly recommend!"
      }
    ]
  },

  // Product 25
  {
    productID: 25,
    images: [
      "path/to/image1.jpg",
      "path/to/image2.jpg",
      "path/to/image3.jpg",
      "path/to/image4.jpg"
    ],
    description: "A regal opal bangle that combines luxury with elegance, perfect for adding a touch of sophistication to your look.",
    additionalInfo: {
      mainHeader: "Regal Opal Bangle",
      mainDescription: "This bangle features a stunning opal stone that symbolizes luxury and elegance. Crafted with precision, it is perfect for any formal occasion.",
      weight: "0.4 kg",
      dimensions: "19 x 2 x 2 cm",
      size: ["S", "M", "L"],
      color: ["Gold"],
      storage: "Store in a cool, dry place.",
      lining: "Gold-plated metal",
      whyChoose: [
        "Exquisite opal stone design.",
        "High-quality gold-plated metal.",
        "Perfect for formal occasions.",
        "Durable and long-lasting.",
        "Available in multiple sizes."
      ],
      shopWithConfidence: [
        "Premium Quality – 100% authentic materials.",
        "Exclusive Designs – Unique opal design.",
        "Safe & Secure Shopping – Hassle-free checkout and reliable delivery."
      ]
    },
    reviews: [
      {
        user: "Olivia Green",
        date: "August 01, 2023",
        rating: 5,
        comment: "This bangle is absolutely beautiful! The opal stone is so elegant and luxurious."
      },
      {
        user: "William Brown",
        date: "August 05, 2023",
        rating: 4,
        comment: "Great quality and design. The bangle looks even better in person."
      }
    ]
  },

  // Product 26
  {
    productID: 26,
    images: [
      "path/to/image1.jpg",
      "path/to/image2.jpg",
      "path/to/image3.jpg",
      "path/to/image4.jpg"
    ],
    description: "Sunbeam cascade earrings that capture the essence of sunlight, perfect for adding a touch of sparkle to your look.",
    additionalInfo: {
      mainHeader: "Sunbeam Cascade Earrings",
      mainDescription: "These earrings feature a cascade of sunbeam-inspired designs that symbolize the beauty of sunlight. Crafted with precision, they are perfect for any occasion.",
      weight: "0.1 kg",
      dimensions: "5 x 2 x 2 cm",
      size: ["One Size"],
      color: ["Gold"],
      storage: "Store in a cool, dry place.",
      lining: "Gold-plated metal",
      whyChoose: [
        "Exquisite sunbeam-inspired design.",
        "High-quality gold-plated metal.",
        "Perfect for gifting or personal use.",
        "Durable and long-lasting.",
        "Elegant and timeless design."
      ],
      shopWithConfidence: [
        "Premium Quality – 100% authentic materials.",
        "Exclusive Designs – Unique sunbeam-inspired design.",
        "Safe & Secure Shopping – Hassle-free checkout and reliable delivery."
      ]
    },
    reviews: [
      {
        user: "Sophia Taylor",
        date: "September 01, 2023",
        rating: 5,
        comment: "These earrings are absolutely stunning! The sunbeam design is so elegant and sparkly."
      },
      {
        user: "Daniel Harris",
        date: "September 05, 2023",
        rating: 4,
        comment: "Great quality and design. The earrings look even better in person."
      }
    ]
  },

  // Product 27
  {
    productID: 27,
    images: [
      "path/to/image1.jpg",
      "path/to/image2.jpg",
      "path/to/image3.jpg",
      "path/to/image4.jpg"
    ],
    description: "A silver twilight necklace that captures the essence of the evening sky, perfect for adding a touch of elegance to your look.",
    additionalInfo: {
      mainHeader: "Silver Twilight Necklace",
      mainDescription: "This necklace features a twilight-inspired design that symbolizes the beauty of the evening sky. Crafted with precision, it is perfect for any occasion.",
      weight: "0.3 kg",
      dimensions: "30 x 1 x 1 cm",
      size: ["One Size"],
      color: ["Gold"],
      storage: "Store in a cool, dry place.",
      lining: "Gold-plated metal",
      whyChoose: [
        "Exquisite twilight-inspired design.",
        "High-quality gold-plated metal.",
        "Perfect for gifting or personal use.",
        "Durable and long-lasting.",
        "Elegant and timeless design."
      ],
      shopWithConfidence: [
        "Premium Quality – 100% authentic materials.",
        "Exclusive Designs – Unique twilight-inspired design.",
        "Safe & Secure Shopping – Hassle-free checkout and reliable delivery."
      ]
    },
    reviews: [
      {
        user: "Emma Wilson",
        date: "October 10, 2023",
        rating: 5,
        comment: "This necklace is absolutely stunning! The twilight design is so elegant and mysterious."
      },
      {
        user: "Noah Martinez",
        date: "October 15, 2023",
        rating: 4,
        comment: "Great quality and design. The necklace looks even better in person."
      }
    ]
  },

  // Product 28
  {
    productID: 28,
    images: [
      "path/to/image1.jpg",
      "path/to/image2.jpg",
      "path/to/image3.jpg",
      "path/to/image4.jpg"
    ],
    description: "A pearlescent halo choker that combines elegance with a touch of mystery, perfect for formal occasions.",
    additionalInfo: {
      mainHeader: "Pearlescent Halo Choker",
      mainDescription: "This choker features a stunning pearlescent halo design that symbolizes elegance and mystery. Crafted with precision, it is perfect for adding a regal touch to your ensemble.",
      weight: "0.25 kg",
      dimensions: "35 x 1 x 1 cm",
      size: ["One Size"],
      color: ["Gold"],
      storage: "Store in a cool, dry place.",
      lining: "Gold-plated metal",
      whyChoose: [
        "Exquisite pearlescent halo design.",
        "High-quality gold-plated metal.",
        "Perfect for formal occasions.",
        "Durable and long-lasting.",
        "Elegant and timeless design."
      ],
      shopWithConfidence: [
        "Premium Quality – 100% authentic materials.",
        "Exclusive Designs – Unique pearlescent halo design.",
        "Safe & Secure Shopping – Hassle-free checkout and reliable delivery."
      ]
    },
    reviews: [
      {
        user: "Sophia Clark",
        date: "December 10, 2023",
        rating: 5,
        comment: "This choker is absolutely stunning! The pearlescent halo design is so elegant and regal."
      },
      {
        user: "Ethan Harris",
        date: "December 15, 2023",
        rating: 4,
        comment: "Great quality and design. The choker looks even better in person."
      }
    ]
  },
    // Product 29
    {
      productID: 29,
      images: [
        "path/to/image1.jpg",
        "path/to/image2.jpg",
        "path/to/image3.jpg",
        "path/to/image4.jpg"
      ],
      description: "A radiant golden pendant that captures the essence of sunlight, perfect for adding a touch of luxury to your look.",
      additionalInfo: {
        mainHeader: "Golden Radiance Pendant",
        mainDescription: "This pendant features a radiant design that symbolizes the beauty of sunlight. Crafted with precision, it is perfect for any occasion.",
        weight: "0.2 kg",
        dimensions: "4 x 2 x 1 cm",
        size: ["One Size"],
        color: ["Gold"],
        storage: "Store in a cool, dry place.",
        lining: "Gold-plated metal",
        whyChoose: [
          "Exquisite radiant design.",
          "High-quality gold-plated metal.",
          "Perfect for gifting or personal use.",
          "Lightweight and comfortable to wear.",
          "Timeless appeal."
        ],
        shopWithConfidence: [
          "Premium Quality – 100% authentic materials.",
          "Exclusive Designs – Unique radiant design.",
          "Safe & Secure Shopping – Hassle-free checkout and reliable delivery."
        ]
      },
      reviews: [
        {
          user: "Emily Davis",
          date: "November 10, 2023",
          rating: 5,
          comment: "This pendant is absolutely stunning! The radiant design is so elegant and luxurious."
        },
        {
          user: "David Wilson",
          date: "November 15, 2023",
          rating: 4,
          comment: "Great quality and design. The pendant looks even better in person."
        }
      ]
    },
  
    // Product 30
    {
      productID: 30,
      images: [
        "path/to/image1.jpg",
        "path/to/image2.jpg",
        "path/to/image3.jpg",
        "path/to/image4.jpg"
      ],
      description: "A gleaming cuff bracelet that captures the essence of the aurora, perfect for adding a touch of elegance to your look.",
      additionalInfo: {
        mainHeader: "Aurora Gleam Cuff",
        mainDescription: "This cuff bracelet features a gleaming design that symbolizes the beauty of the aurora. Crafted with precision, it is perfect for any occasion.",
        weight: "0.4 kg",
        dimensions: "6 x 4 x 2 cm",
        size: ["Adjustable"],
        color: ["Gold"],
        storage: "Store in a soft pouch to avoid scratches.",
        lining: "Gold-plated metal",
        whyChoose: [
          "Luxurious gold-plated finish.",
          "Adjustable fit for comfort.",
          "Perfect for formal and casual wear.",
          "Durable and stylish.",
          "An exquisite gift choice."
        ],
        shopWithConfidence: [
          "High-Quality Craftsmanship.",
          "Exclusive & Elegant Design.",
          "Secure Shopping & Reliable Delivery."
        ]
      },
      reviews: [
        {
          user: "Sophia Taylor",
          date: "October 20, 2023",
          rating: 5,
          comment: "This cuff is absolutely stunning! The aurora design is so elegant and unique."
        },
        {
          user: "Daniel Harris",
          date: "October 25, 2023",
          rating: 4,
          comment: "Great quality and design. The cuff looks even better in person."
        }
      ]
    },
  
    // Product 31
    {
      productID: 31,
      images: [
        "path/to/image1.jpg",
        "path/to/image2.jpg",
        "path/to/image3.jpg",
        "path/to/image4.jpg"
      ],
      description: "A gilded anklet that captures the essence of moonlight, perfect for adding a touch of elegance to your look.",
      additionalInfo: {
        mainHeader: "Gilded Moon Anklet",
        mainDescription: "This anklet features a gilded design that symbolizes the beauty of moonlight. Crafted with precision, it is perfect for any occasion.",
        weight: "0.15 kg",
        dimensions: "22 x 1 x 1 cm",
        size: ["Adjustable"],
        color: ["Gold"],
        storage: "Keep away from moisture for lasting shine.",
        lining: "Gold-plated metal",
        whyChoose: [
          "Elegant gilded design.",
          "Comfortable and lightweight.",
          "Perfect for daily wear.",
          "Trendy and stylish.",
          "A great gifting option."
        ],
        shopWithConfidence: [
          "100% Authentic Materials.",
          "Handcrafted for Uniqueness.",
          "Hassle-Free Shopping Experience."
        ]
      },
      reviews: [
        {
          user: "Olivia Martinez",
          date: "November 25, 2023",
          rating: 5,
          comment: "This anklet is absolutely beautiful! The gilded design is so elegant and unique."
        },
        {
          user: "Liam Johnson",
          date: "November 30, 2023",
          rating: 4,
          comment: "Great quality and design. The anklet looks even better in person."
        }
      ]
    },
  
    // Product 32
    {
      productID: 32,
      images: [
        "path/to/image1.jpg",
        "path/to/image2.jpg",
        "path/to/image3.jpg",
        "path/to/image4.jpg"
      ],
      description: "A luminous ring that captures the essence of dreams, perfect for adding a touch of elegance to your look.",
      additionalInfo: {
        mainHeader: "Luminous Dream Ring",
        mainDescription: "This ring features a luminous design that symbolizes the beauty of dreams. Crafted with precision, it is perfect for any occasion.",
        weight: "0.25 kg",
        dimensions: "2 x 2 x 1 cm",
        size: ["6", "7", "8", "9"],
        color: ["Gold"],
        storage: "Store in a cool, dry place.",
        lining: "Gold-plated metal",
        whyChoose: [
          "Exquisite luminous design.",
          "High-quality gold-plated metal.",
          "Perfect for gifting or personal use.",
          "Durable and long-lasting.",
          "Elegant and timeless design."
        ],
        shopWithConfidence: [
          "Premium Quality – 100% authentic materials.",
          "Exclusive Designs – Unique luminous design.",
          "Safe & Secure Shopping – Hassle-free checkout and reliable delivery."
        ]
      },
      reviews: [
        {
          user: "Emma Wilson",
          date: "October 10, 2023",
          rating: 5,
          comment: "This ring is absolutely stunning! The luminous design is so elegant and sparkly."
        },
        {
          user: "Noah Martinez",
          date: "October 15, 2023",
          rating: 4,
          comment: "Great quality and design. The ring looks even better in person."
        }
      ]
    },
    // Product 33
  {
    productID: 33,
    images: [
      "path/to/image1.jpg",
      "path/to/image2.jpg",
      "path/to/image3.jpg",
      "path/to/image4.jpg"
    ],
    description: "A nocturnal glow bracelet that captures the essence of the night, perfect for adding a touch of mystery to your look.",
    additionalInfo: {
      mainHeader: "Nocturnal Glow Bracelet",
      mainDescription: "This bracelet features a nocturnal-inspired design that symbolizes the beauty of the night. Crafted with precision, it is perfect for any occasion.",
      weight: "0.3 kg",
      dimensions: "18 x 2 x 2 cm",
      size: ["S", "M", "L"],
      color: ["Gold"],
      storage: "Store in a cool, dry place.",
      lining: "Gold-plated metal",
      whyChoose: [
        "Exquisite nocturnal-inspired design.",
        "High-quality gold-plated metal.",
        "Perfect for gifting or personal use.",
        "Durable and long-lasting.",
        "Elegant and timeless design."
      ],
      shopWithConfidence: [
        "Premium Quality – 100% authentic materials.",
        "Exclusive Designs – Unique nocturnal-inspired design.",
        "Safe & Secure Shopping – Hassle-free checkout and reliable delivery."
      ]
    },
    reviews: [
      {
        user: "Sophia Clark",
        date: "December 10, 2023",
        rating: 5,
        comment: "This bracelet is absolutely stunning! The nocturnal design is so elegant and unique."
      },
      {
        user: "Ethan Harris",
        date: "December 15, 2023",
        rating: 4,
        comment: "Great quality and design. The bracelet looks even better in person."
      }
    ]
  },

  // Product 34
  {
    productID: 34,
    images: [
      "path/to/image1.jpg",
      "path/to/image2.jpg",
      "path/to/image3.jpg",
      "path/to/image4.jpg"
    ],
    description: "An empress luxe bangle that combines luxury with elegance, perfect for adding a touch of sophistication to your look.",
    additionalInfo: {
      mainHeader: "Empress Luxe Bangle",
      mainDescription: "This bangle features a luxurious design that symbolizes power and elegance. Crafted with precision, it is perfect for any formal occasion.",
      weight: "0.4 kg",
      dimensions: "19 x 2 x 2 cm",
      size: ["S", "M", "L"],
      color: ["Gold"],
      storage: "Store in a cool, dry place.",
      lining: "Gold-plated metal",
      whyChoose: [
        "Exquisite luxurious design.",
        "High-quality gold-plated metal.",
        "Perfect for formal occasions.",
        "Durable and long-lasting.",
        "Available in multiple sizes."
      ],
      shopWithConfidence: [
        "Premium Quality – 100% authentic materials.",
        "Exclusive Designs – Unique luxurious design.",
        "Safe & Secure Shopping – Hassle-free checkout and reliable delivery."
      ]
    },
    reviews: [
      {
        user: "Olivia Green",
        date: "August 01, 2023",
        rating: 5,
        comment: "This bangle is absolutely beautiful! The luxurious design is so elegant and regal."
      },
      {
        user: "William Brown",
        date: "August 05, 2023",
        rating: 4,
        comment: "Great quality and design. The bangle looks even better in person."
      }
    ]
  },

  // Product 35
  {
    productID: 35,
    images: [
      "path/to/image1.jpg",
      "path/to/image2.jpg",
      "path/to/image3.jpg",
      "path/to/image4.jpg"
    ],
    description: "A moonlit whisper necklace that captures the essence of the night sky, perfect for adding a touch of elegance to your look.",
    additionalInfo: {
      mainHeader: "Moonlit Whisper Necklace",
      mainDescription: "This necklace features a moonlit-inspired design that symbolizes the beauty of the night sky. Crafted with precision, it is perfect for any occasion.",
      weight: "0.3 kg",
      dimensions: "30 x 1 x 1 cm",
      size: ["One Size"],
      color: ["Gold"],
      storage: "Store in a cool, dry place.",
      lining: "Gold-plated metal",
      whyChoose: [
        "Exquisite moonlit-inspired design.",
        "High-quality gold-plated metal.",
        "Perfect for gifting or personal use.",
        "Durable and long-lasting.",
        "Elegant and timeless design."
      ],
      shopWithConfidence: [
        "Premium Quality – 100% authentic materials.",
        "Exclusive Designs – Unique moonlit-inspired design.",
        "Safe & Secure Shopping – Hassle-free checkout and reliable delivery."
      ]
    },
    reviews: [
      {
        user: "Emma Wilson",
        date: "October 10, 2023",
        rating: 5,
        comment: "This necklace is absolutely stunning! The moonlit design is so elegant and mysterious."
      },
      {
        user: "Noah Martinez",
        date: "October 15, 2023",
        rating: 4,
        comment: "Great quality and design. The necklace looks even better in person."
      }
    ]
  },

  // Product 36
  {
    productID: 36,
    images: [
      "path/to/image1.jpg",
      "path/to/image2.jpg",
      "path/to/image3.jpg",
      "path/to/image4.jpg"
    ],
    description: "A dusky shine ring that captures the essence of twilight, perfect for adding a touch of elegance to your look.",
    additionalInfo: {
      mainHeader: "Dusky Shine Ring",
      mainDescription: "This ring features a dusky-inspired design that symbolizes the beauty of twilight. Crafted with precision, it is perfect for any occasion.",
      weight: "0.25 kg",
      dimensions: "2 x 2 x 1 cm",
      size: ["6", "7", "8", "9"],
      color: ["Gold"],
      storage: "Store in a cool, dry place.",
      lining: "Gold-plated metal",
      whyChoose: [
        "Exquisite dusky-inspired design.",
        "High-quality gold-plated metal.",
        "Perfect for gifting or personal use.",
        "Durable and long-lasting.",
        "Elegant and timeless design."
      ],
      shopWithConfidence: [
        "Premium Quality – 100% authentic materials.",
        "Exclusive Designs – Unique dusky-inspired design.",
        "Safe & Secure Shopping – Hassle-free checkout and reliable delivery."
      ]
    },
    reviews: [
      {
        user: "Ava Anderson",
        date: "September 20, 2023",
        rating: 5,
        comment: "This ring is absolutely stunning! The dusky design is so elegant and sparkly."
      },
      {
        user: "Liam Thomas",
        date: "September 25, 2023",
        rating: 4,
        comment: "Great quality and design. The ring looks even better in person."
      }
    ]
  },

  // Product 37
  {
    productID: 37,
    images: [
      "path/to/image1.jpg",
      "path/to/image2.jpg",
      "path/to/image3.jpg",
      "path/to/image4.jpg"
    ],
    description: "Golden aura earrings that capture the essence of sunlight, perfect for adding a touch of luxury to your look.",
    additionalInfo: {
      mainHeader: "Golden Aura Earrings",
      mainDescription: "These earrings feature a radiant design that symbolizes the beauty of sunlight. Crafted with precision, they are perfect for any occasion.",
      weight: "0.15 kg",
      dimensions: "5 x 2 x 2 cm",
      size: ["One Size"],
      color: ["Gold"],
      storage: "Store in a cool, dry place.",
      lining: "Gold-plated metal",
      whyChoose: [
        "Exquisite radiant design.",
        "High-quality gold-plated metal.",
        "Perfect for gifting or personal use.",
        "Durable and long-lasting.",
        "Elegant and timeless design."
      ],
      shopWithConfidence: [
        "Premium Quality – 100% authentic materials.",
        "Exclusive Designs – Unique radiant design.",
        "Safe & Secure Shopping – Hassle-free checkout and reliable delivery."
      ]
    },
    reviews: [
      {
        user: "Sophia Taylor",
        date: "October 20, 2023",
        rating: 5,
        comment: "These earrings are absolutely stunning! The radiant design is so elegant and luxurious."
      },
      {
        user: "Daniel Harris",
        date: "October 25, 2023",
        rating: 4,
        comment: "Great quality and design. The earrings look even better in person."
      }
    ]
  },
   // Product 38
   {
    productID: 38,
    images: [
      "path/to/image1.jpg",
      "path/to/image2.jpg",
      "path/to/image3.jpg",
      "path/to/image4.jpg"
    ],
    description: "A mystic gem choker that combines elegance with a touch of mystery, perfect for formal occasions.",
    additionalInfo: {
      mainHeader: "Mystic Gem Choker",
      mainDescription: "This choker features a stunning gemstone design that symbolizes elegance and mystery. Crafted with precision, it is perfect for adding a regal touch to your ensemble.",
      weight: "0.25 kg",
      dimensions: "35 x 1 x 1 cm",
      size: ["One Size"],
      color: ["Gold"],
      storage: "Store in a cool, dry place.",
      lining: "Gold-plated metal",
      whyChoose: [
        "Exquisite gemstone design.",
        "High-quality gold-plated metal.",
        "Perfect for formal occasions.",
        "Durable and long-lasting.",
        "Elegant and timeless design."
      ],
      shopWithConfidence: [
        "Premium Quality – 100% authentic materials.",
        "Exclusive Designs – Unique gemstone design.",
        "Safe & Secure Shopping – Hassle-free checkout and reliable delivery."
      ]
    },
    reviews: [
      {
        user: "Sophia Clark",
        date: "December 10, 2023",
        rating: 5,
        comment: "This choker is absolutely stunning! The gemstone design is so elegant and regal."
      },
      {
        user: "Ethan Harris",
        date: "December 15, 2023",
        rating: 4,
        comment: "Great quality and design. The choker looks even better in person."
      }
    ]
  },

  // Product 39
  {
    productID: 39,
    images: [
      "path/to/image1.jpg",
      "path/to/image2.jpg",
      "path/to/image3.jpg",
      "path/to/image4.jpg"
    ],
    description: "A velvet sun pendant that captures the essence of sunlight, perfect for adding a touch of luxury to your look.",
    additionalInfo: {
      mainHeader: "Velvet Sun Pendant",
      mainDescription: "This pendant features a radiant sun design that symbolizes the beauty of sunlight. Crafted with precision, it is perfect for any occasion.",
      weight: "0.2 kg",
      dimensions: "4 x 2 x 1 cm",
      size: ["One Size"],
      color: ["Gold"],
      storage: "Store in a cool, dry place.",
      lining: "Gold-plated metal",
      whyChoose: [
        "Exquisite sun-inspired design.",
        "High-quality gold-plated metal.",
        "Perfect for gifting or personal use.",
        "Lightweight and comfortable to wear.",
        "Timeless appeal."
      ],
      shopWithConfidence: [
        "Premium Quality – 100% authentic materials.",
        "Exclusive Designs – Unique sun-inspired design.",
        "Safe & Secure Shopping – Hassle-free checkout and reliable delivery."
      ]
    },
    reviews: [
      {
        user: "Emily Davis",
        date: "November 10, 2023",
        rating: 5,
        comment: "This pendant is absolutely stunning! The sun design is so elegant and luxurious."
      },
      {
        user: "David Wilson",
        date: "November 15, 2023",
        rating: 4,
        comment: "Great quality and design. The pendant looks even better in person."
      }
    ]
  },

  // Product 40
  {
    productID: 40,
    images: [
      "path/to/image1.jpg",
      "path/to/image2.jpg",
      "path/to/image3.jpg",
      "path/to/image4.jpg"
    ],
    description: "Celestial hoop earrings that capture the essence of the night sky, perfect for adding a touch of elegance to your look.",
    additionalInfo: {
      mainHeader: "Celestial Hoop Earrings",
      mainDescription: "These earrings feature a celestial-inspired design that symbolizes the beauty of the night sky. Crafted with precision, they are perfect for any occasion.",
      weight: "0.15 kg",
      dimensions: "5 x 2 x 2 cm",
      size: ["One Size"],
      color: ["Gold"],
      storage: "Store in a cool, dry place.",
      lining: "Gold-plated metal",
      whyChoose: [
        "Exquisite celestial-inspired design.",
        "High-quality gold-plated metal.",
        "Perfect for gifting or personal use.",
        "Durable and long-lasting.",
        "Elegant and timeless design."
      ],
      shopWithConfidence: [
        "Premium Quality – 100% authentic materials.",
        "Exclusive Designs – Unique celestial-inspired design.",
        "Safe & Secure Shopping – Hassle-free checkout and reliable delivery."
      ]
    },
    reviews: [
      {
        user: "Sophia Taylor",
        date: "October 20, 2023",
        rating: 5,
        comment: "These earrings are absolutely stunning! The celestial design is so elegant and unique."
      },
      {
        user: "Daniel Harris",
        date: "October 25, 2023",
        rating: 4,
        comment: "Great quality and design. The earrings look even better in person."
      }
    ]
  }


      // Continue adding product details for the remaining 32 items...
    ];
    
  
  export default ProductDetail;